var render = function render(){var _vm=this,_c=_vm._self._c;return _c('webpay-doc',{scopedSlots:_vm._u([{key:"doc-content",fn:function(){return [_c('div',{staticClass:"api-content",domProps:{"innerHTML":_vm._s(_vm.htmlCont)}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }